import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/font-awesome.min.css";
import "./styles/linearicons.css";
import "./styles/main.css";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import CaseStudy from "./pages/CaseStudy";
import Packages from "./pages/Packages";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import NoPageFound from "./pages/NoPageFound";
import UnderConstruction from "./pages/UnderConstruction";
import Disclaimer from "./pages/Disclaimer";
import RefundPolicy from "./pages/RefundPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Careers from "./pages/Careers";
import NonDisclosureAgreement from "./pages/NonDisclosureAgreement";
import UiUxProjectPage from "./pages/UiUxProjectPage";
import ThemeStore from "./pages/ThemeStore";
import ThemePreview from "./pages/ThemePreview";
import { GoogleAnalyticsActions } from "./GoogleAnalytics/GoogleAnalyticsConfig";

const GA_MEASUREMENT_ID = "G-F8D8HP6X1J";

function App() {
  const location = useLocation();

  useEffect(() => {
    GoogleAnalyticsActions.initGoogleAnalytics(GA_MEASUREMENT_ID);
  }, []);

  useEffect(() => {
    GoogleAnalyticsActions.trackPageview(location.pathname + location.search);
  }, [location]);

  return (
    <div className="App">
      <Routes>
        {/* "home" removed: internal links now point to "/", and a
            firebase.json redirect sends any remaining "/home" request
            straight to "/" before it reaches this router. */}
        <Route path="/" exact element={<Home />}></Route>
        <Route path="about" exact element={<About />}></Route>
        {/* <Route path="services" exact element={<Services />}></Route> */}
        <Route path="portfolio" exact element={<Portfolio />}></Route>
        <Route path="case-study" exact element={<CaseStudy />}></Route>
        <Route path="packages" exact element={<Packages />}></Route>
        <Route path="careers" exact element={<Careers />}></Route>
        <Route path="contact-us" exact element={<Contact />}></Route>
        <Route path="disclaimer" exact element={<Disclaimer />}></Route>
        <Route
          path="terms-and-conditions"
          exact
          element={<TermsAndConditions />}
        ></Route>
        <Route path="privacy-policy" exact element={<Privacy />}></Route>
        <Route path="refund-policy" exact element={<RefundPolicy />}></Route>
        <Route
          path="non-disclosure-agreement"
          exact
          element={<NonDisclosureAgreement />}
        ></Route>

        <Route path="services/:id" exact element={<Services />}></Route>
        <Route
          path="ui-ux-project/:id"
          exact
          element={<UiUxProjectPage />}
        ></Route>

        <Route
          path="under-construction"
          exact
          element={<UnderConstruction />}
        ></Route>
        <Route path="theme-store" exact element={<ThemeStore />}></Route>
        <Route path="theme/:id" exact element={<ThemePreview />}></Route>
        <Route path="*" exact element={<NoPageFound />}></Route>
      </Routes>
    </div>
  );
}

export default App;
